import React, { Component } from "react";
import PropTypes from "prop-types";
import Swiper from "react-id-swiper";
import RecommendedItemCard from "./RecommendationItemCard";

require("./RecommendationsCarousel.scss");

class RecommendationsCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPrev: false,
      showNext: false,
      shouldSwiperUpdate: false,
    };
  }

  defaultCarouselProps = {
    loop: false,
    allowTouchMove: false,
    slidesPerView: 1.5,
    spaceBetween: 15,
    pagination: {
      el: ".swiper-pagination",
      type: "progress",
    },
    navigation: {
      nextEl: ".sliderButtonNext",
      prevEl: ".sliderButtonPrev",
    },
    lazy: true,
    autoplay: false,
  };

  nextButton = () => {
    return (
      <div
        onClick={this.handleClickNext}
        className={`sliderButtonNext nextArrow ${
          !this.state.showNext ? "hideNav" : ""
        }`}
      >
        <img alt=">" src={require("@images/move-right.png")} />
      </div>
    );
  };

  prevButton = () => {
    return (
      <div
        onClick={this.handleClickPrev}
        className={`sliderButtonPrev prevArrow ${
          !this.state.showPrev ? "hideNav" : ""
        }`}
      >
        <img alt="<" src={require("@images/move-right.png")} />
      </div>
    );
  };

  componentWillMount() {
    this.setState({
      showNext: this.props.numberOfRecommendations > 1,
      shouldSwiperUpdate: this.props.numberOfRecommendations > 2,
    });
  }

  componentDidUpdate(prev) {
    if (this.props.numberOfRecommendations !== prev.numberOfRecommendations) {
      this.setState({
        showNext: this.props.numberOfRecommendations > 1,
        shouldSwiperUpdate: this.props.numberOfRecommendations > 2,
        showPrev: false
      });
    }
  }

  reachBeginning = () => {
    this.setState({
      showPrev: false,
    });
  };

  reachEnd = () => {
    this.setState({
      showNext: false,
    });
  };

  handleClickNext = () => {
    this.setState({
      showPrev: true,
    });
  };

  handleClickPrev = () => {
    this.setState({
      showNext: true && this.props.numberOfRecommendations > 1,
    });
  };

  render() {
    return (
      <div className="SliderComponentWrapper">
        <Swiper
          {...this.defaultCarouselProps}
          renderNextButton={this.nextButton}
          renderPrevButton={this.prevButton}
          on={{
            reachBeginning: this.reachBeginning,
            reachEnd: this.reachEnd,
          }}
          shouldSwiperUpdate={this.state.shouldSwiperUpdate}
          slideActiveClass="sliderActiveMultiple"
          ref={(node) => (this.swiper = node)}
        >
          {this.props.recommendedItems.map((item, index) => (
            <div key={item.productId}>
              <RecommendedItemCard
                recommendedItem={item}
                rank={index}
                numberOfRecommendations={this.props.numberOfRecommendations}
                recommendationType={this.props.recommendationType}
                removeRecommendedItem={(data) => {
                  this.props.removeRecommendedItem(data);
                  this.swiper && this.swiper.rebuildSwiper();
                }}
                enableAddressSelection={this.props.enableAddressSelection}
                widgetId={this.props.widgetId}
              />
            </div>
          ))}
        </Swiper>
      </div>
    );
  }
}

RecommendedItemCard.defaultProps = {
  numberOfRecommendations: 0,
  recommendationType: 1,
};

RecommendationsCarousel.propTypes = {
  recommendedItems: PropTypes.array.isRequired,
  numberOfRecommendations: PropTypes.number,
  recommendationType: PropTypes.number,
  removeRecommendedItem: PropTypes.func.isRequired,
  enableAddressSelection: PropTypes.func.isRequired,
  widgetId: PropTypes.number.isRequired,
};

export default RecommendationsCarousel;
